<template>
  <div class="app-container">
    <div class="info-box">
      <div class="left-box" v-if="!isMB">
        <div class="topSelect">
          学期名称：
          <el-select v-model="TermId" @change="termChange" size="small" class="tselect">
            <el-option
              v-for="item in termList"
              :key="item.TermId"
              :value="item.TermId"
              :label="item.TermName"
            ></el-option>
          </el-select>
          <!-- <el-button icon="el-icon-caret-top" type="text" style="padding:7px;margin-left:20px;" v-if="isMB" @click="showTree=false">收起</el-button> -->
        </div>
        <div class="left-title">
          <span style="cursor: pointer;" @click="allData">所有班级</span>
          <!-- <el-button type="text" @click="createTree" icon="el-icon-circle-plus-outline"></el-button> -->
        </div>
        <div class="left-main">
          <sc-tree ref="scTree" @on-select="onSelect" @on-pselect="onPselect"></sc-tree>
        </div>
      </div>
      <div class="main-box">
        <list ref="list" :canSearch="canSearch" @setadd="setcanAdd">
          <template slot="toolbar-right" v-if="$permission.canWrite()">
            <el-button size="mini" type="primary" plain @click="exportInfo" v-if="!isMB">导出班级信息</el-button>
            <el-button size="mini" type="primary" @click="elective">设置选修</el-button>
            <el-button size="mini" type="primary" @click="changeClass">调班级</el-button>
            <el-button size="mini" type="primary" @click="changeDorm">调宿舍</el-button>
            <el-button size="mini" type="success" plain @click="importCourse" v-if="!isMB">导入选修</el-button>
            <el-button size="mini" type="success" plain @click="importClass" v-if="!isMB">导入调班</el-button>
            <el-button size="mini" type="success" plain @click="importDorm" v-if="!isMB">导入调宿舍</el-button>
            <el-button
              :disabled="!canAdd"
              size="mini"
              type="primary"
              @click="toAdd"
            >添加</el-button>
            <el-button
              size="mini"
              type="danger"
              @click="delRows"
              :style="isMB?'margin:10px 0 0 10px':'margin-right:10px'"
            >删除</el-button>
            <!-- <el-button size="mini" type="success" @click="showTree=true" style="margin:10px 0 0 0" v-if="isMB">筛选</el-button> -->
          </template>
        </list>
      </div>
    </div>
    <edit-dialog ref="editDialog" @close-saved="toReload"></edit-dialog>
    <st-dialog ref="stDialog" in-dialog selectable :multiple="true" @select-multiple="setST" />
    <class-dialog ref="classDialog" @setClass="changeClassRange" />
    <dorm-dialog ref="dormDialog" in-dialog selectable :multiple="false" @select="changeDormRange" />
    <import-dialog ref="importDialog" @upload-success="toReload" />
    <dormimport-dialog ref="dormimportDialog" @upload-success="toReload" />
    <elective-import-dialog ref="electiveImportDialog" @upload-success="toReload" />
    <elective-dialog ref="electiveDialog" @set-elective="toReload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/st/sc/list";
import editDialog from "@/components/st/sc/editDialog";
import scTree from "@/components/st/sc/scTree/tree";
import stDialog from "@/components/st/student/listDialog";
import api from "@/api/st/studentclass";
import termApi from "@/api/ed/term";
import classDialog from "@/components/ed/class/classDialog";
import dormDialog from "@/components/lo/dorm/listDialog";
import importDialog from "@/components/st/sc/classImportDialog";
import dormimportDialog from "@/components/st/sc/dormImportDialog";
import electiveImportDialog from "@/components/st/sc/electiveImportDialog";
import electiveDialog from "@/components/st/sc/electiveDialog";

export default {
  name: "sc",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    scTree,
    stDialog,
    classDialog,
    dormDialog,
    importDialog,
    dormimportDialog,
    electiveImportDialog,
    electiveDialog,
  },
  data() {
    return {
      data: {
        ClassId: null,
        ClassName: "",
        GradeId: null,
      },
      canSearch: true,
      canAdd: false,
      api,
      termApi,
      TermId: null,
      TermName: "",
      TermNumber: "",
      termList: [],
      ids: [],
      StudentIds: [],
      StudentDormitoryIds: [],
      isMB: this.$store.state.isMB,
    };
  },
  mounted() {
    if (!this.isMB) {
      this.termApi.list().then((res) => {
        this.termList = res.Data || [];
        if (res.Data.length > 0) {
          let tid = res.Data[0].TermId;
          this.TermId = tid;
          this.TermName = res.Data[0].TermName;
          this.TermNumber = res.Data[0].TermNumber;
          this.$refs.scTree.getData(tid);
          this.toReload();
          sessionStorage.setItem("termId", tid);
        }
      });
    }
  },
  methods: {
    exportInfo() {
      this.$refs.list.export({
        TermId: this.TermId,
        ClassId: this.data.ClassId,
        GradeId: this.data.GradeId,
      });
    },
    termChange(e) {
      this.canAdd = false;
      this.$refs.scTree.getData(e);
      // this.canSearch = true
      sessionStorage.setItem("termId", e);
      this.termList.forEach((item) => {
        if (e == item.TermId) {
          this.TermName = item.TermName;
          this.TermNumber = item.TermNumber;
        }
      });
      this.$refs.list.getData({ TermId: e });
    },
    toReload() {
      this.$refs.list.reload();
      // if(this.data.ClassId) {
      //   this.$refs.list.query({TermId: this.TermId, ClassId: this.data.ClassId})
      // } else if(this.GradId) {
      //   this.$refs.list.query({TermId: this.TermId, GradId: this.data.GradId })
      // } else {
      //   this.$refs.list.query({TermId: this.TermId })
      // }
    },
    elective() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择学生");
        return;
      }
      var data = {
        TermId: this.TermId,
        StudentIds: rows.map((x) => x.StudentId),
      };
      this.$refs.electiveDialog.open(data);
    },
    reload() {},
    allData() {
      this.resetSelect();
      this.$refs.list.getData({ TermId: this.TermId });
      console.log("allData", this.data);
      this.canAdd = false;
    },
    resetSelect() {
      this.$refs.scTree.resetSelect();
      this.data.ClassId = null;
      this.data.ClassName = "";
    },
    onSelect(data) {
      console.log("onSelect", data);
      // if (this.data.ClassId != data.Id) {
      this.data.ClassId = data.Id;
      this.data.ClassName = data.Name;
      // this.canSearch = true
      this.$refs.TermId = this.TermId;
      // sessionStorage.setItem("termId",this.TermId)
      this.$refs.list.params.ClassId = this.Id;
      this.$refs.list.getData({ ClassId: data.Id, TermId: this.TermId });
      this.canAdd = true;
      // }
    },
    onPselect(data) {
      console.log(data);
      if (this.data.GradeId != data.Id) {
        this.data.ClassId = null;
        this.$refs.list.getData({ TermId: this.TermId, GradeId: data.Id });
        this.canAdd = false;
      }
    },
    createTree() {
      this.$refs.scTree.create();
    },
    create() {
      this.$refs.editDialog.openCreate(this.data);
    },
    toAdd() {
      this.$refs.stDialog.open().then((that) => {
        that.getData({ NotInTermId: this.TermId });
      });
    },
    setST(st) {
      if (st.length == 0) {
        return;
      }
      let StudentIds = [];
      st.forEach((e) => {
        StudentIds.push(e.StudentId);
      });
      this.api
        .addStudentClass({
          TermId: this.TermId,
          ClassId: this.data.ClassId,
          StudentIds,
        })
        .then((res) => {
          if (res.Code == 0) {
            this.$message.success("添加成功");
            this.$refs.list.query({
              ClassId: this.data.ClassId,
              TermId: this.TermId,
            });
          } else {
            this.$message.error("添加失败，" + res.Msg);
          }
        });
    },
    //-----调班级-----
    changeClass() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要调动的数据");
        return;
      }
      let ids = rows.map((item) => {
        return item.StudentClassId;
      });
      this.ids = ids;
      this.$refs.classDialog.open(rows[0].GradeId);
    },
    changeClassRange(ClassId) {
      this.api.changeClass({ Ids: this.ids, ClassId }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("修改成功");
          this.$refs.list.reload();
          this.$refs.classDialog.close();
        } else {
          this.$message.error("修改失败，" + res.Msg);
        }
      });
    },
    //-----------------------
    //--------调宿舍---------
    changeDorm() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要调动的数据");
        return;
      }
      let ids = rows.map((item) => {
        return item.StudentId;
      });
      this.StudentIds = ids;
      let StudentDormitoryIds = rows.map((item) => {
        return item.StudentDormitoryId;
      });
      this.StudentDormitoryIds = StudentDormitoryIds;
      this.$refs.dormDialog.open().then((that) => {
        that.getData();
      });
    },
    changeDormRange(dorm) {
      this.api
        .changeDormitory({
          StudentIds: this.StudentIds,
          StudentDormitoryIds: this.StudentDormitoryIds,
          TermId: this.TermId,
          DormitoryId: dorm.DormitoryId,
        })
        .then((res) => {
          if (res.Code == 0) {
            this.$message.success("修改成功");
            this.$refs.list.reload();
          } else {
            this.$message.error("修改失败，" + res.Msg);
          }
        });
    },
    //-----------------------
    importClass() {
      this.$refs.importDialog.TermId = this.TermId;
      this.$refs.importDialog.TermName = this.TermName;
      this.$refs.importDialog.open();
    },
    importDorm() {
      this.$refs.dormimportDialog.TermId = this.TermId;
      this.$refs.dormimportDialog.TermName = this.TermName;
      this.$refs.dormimportDialog.open();
    },
    importCourse() {
      this.$refs.electiveImportDialog.TermId = this.TermId;
      this.$refs.electiveImportDialog.TermName = this.TermName;
      this.$refs.electiveImportDialog.open();
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.StudentClassId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
    setcanAdd(e) {
      this.canAdd = e;
    },
  },
};
</script>
<style lang="less" scoped>
.info-box {
  display: flex;
  display: -webkit-flex;
  display: -webkit-inline-flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
}
.left-box {
  width: 250px;
  height: calc(100vh - 105px);
  min-width: 250px;
  border: 1px solid #e4e7ed;
  .left-title {
    padding-left: 25px;
    color: #606266;
    background-color: #ebeef5;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    line-height: 40px;
    padding-right: 8px;
    .el-button--text {
      font-size: 18px;
    }
  }
  .left-main {
    height: calc(100% - 72px);
    overflow: auto;
  }
}
.mbLB {
  z-index: 5;
  background-color: #fff;
  position: fixed;
  top: -100%;
  width: 100%;
  transition-duration: 0.5s;
  left: 0;
  padding-top: 10px;
  margin-top: -10px;
  max-height: 90%;
  padding-bottom: 30px;
  overflow: auto;
}
.showLB {
  top: 14%;
}
.main-box {
  width: 100%;
  overflow: auto;
  @media screen and (min-width: 768px) {
    margin-left: 10px;
    padding: 10px;
    border: 1px solid #e4e7ed;
  }
}
.el-form-item {
  margin-bottom: 0;
}
.footer {
  border-top: 1px solid #e4e7ed;
  padding: 10px 20px 20px;
  text-align: right;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 50px 20px 0px 20px;
  @media screen and (max-width: 767px) {
    margin-top: 10px;
  }
  .el-button {
    width: 80px;
  }
}
.image-slot {
  font-size: 36px;
  color: #909399;
  position: absolute;
  top: 50%;
  left: 50%;
  /* 这里有兼容性问题 */
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.avatar {
  height: 100%;
  display: block;
}
.topSelect {
  text-align: center;
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  .tselect {
    width: 150px;
    @media screen and (min-width: 768px) {
      float: right;
    }
  }
  /deep/ .el-input__inner {
    border-radius: 0px !important;
  }
}
</style>